import { css } from 'styled-components';
import {
  getSpacing, getTypography, SpacingName, TypographyName, ThemedFunctor, BreakpointQueryName,
} from '@doveit/lego';
import { AdvFluidVariant } from '../../../domain/graphcms';

export const base: ThemedFunctor = ({
  theme,
  $variant,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.SMALLER, SpacingName.SMALLER, SpacingName.SMALLER, SpacingName.SMALL])}
  background-color: ${$variant === AdvFluidVariant.VARIANT_1 ? theme.palettes.brand.secondary : theme.palettes.neutrals.lighter};
  border-radius: 6px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  position: relative;
  text-align: center;

  &:hover {
    cursor: pointer;
  }
`;

export const left: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.margin(theme, [SpacingName.SMALLER, SpacingName.SMALL, SpacingName.SMALLER, 0])}
  flex-shrink: 0;
  line-height: 0;
`;

export const center: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.margin(theme, [SpacingName.SMALLER, SpacingName.SMALL, SpacingName.SMALLER, 0])}
  display: flex;
  flex: 1 0;
  flex-direction: column;
  justify-items: center;
  min-width: 10rem;
  text-align: left;

  ${theme.breakpoints.down(BreakpointQueryName.SM)} {
    flex-basis: 100%;
    min-width: 100%;
    width: 100%;
  }
`;

export const right: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.margin(theme, [SpacingName.SMALLER, SpacingName.SMALLER, SpacingName.SMALLER, 0])}
  align-items: flex-end;
  display: flex;
  flex-shrink: 1;

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    flex-shrink: 0;
  }
`;

export const title: ThemedFunctor = ({
  theme,
  $variant,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
  color: ${$variant === AdvFluidVariant.VARIANT_1
    ? theme.palettes.neutrals.lightest
    : theme.palettes.brand.primary};
`;

export const description: ThemedFunctor = ({
  theme,
  $variant,
}) => css`
  ${getTypography(theme, TypographyName.SMALL)}
  color: ${$variant === AdvFluidVariant.VARIANT_1
    ? theme.palettes.neutrals.lightest
    : theme.palettes.neutrals.dark};
  margin-top: .5rem;
`;

export const logo: ThemedFunctor = ({
  theme,
  $variant,
}) => css`
  width: 5rem;
  color: ${$variant === AdvFluidVariant.VARIANT_1
    ? theme.palettes.neutrals.lightest
    : theme.palettes.brand.primary};
  position: absolute;
  right: ${theme.spaceUnits.mobile.SMALL};
  top: ${theme.spaceUnits.mobile.SMALL};

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    right: ${theme.spaceUnits.desktop.SMALL};
    top: ${theme.spaceUnits.desktop.SMALL};
  }
`;
